import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class SimpleAddressService {
  constructor(private http: HttpClientService) {}

  public post(simple_address): Observable<any[]> {
    let options = {
      simple_address,
    };
    return this.http
      .post("/api/simple_address", simple_address)
      .pipe(tap((_) => console.log("SimpleAddressService.post: Ok")));
  }

  public update(simple_address_id, addressParams): Observable<any> {
    return this.http
      .put("/api/simple_address/" + simple_address_id, addressParams)
      .pipe(tap((_) => console.log("SimpleAddressService.update: Ok.")));
  }
}
